import { HierarchyContextProps, IHierarchyActionRemoveHierarchyComment } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Removes a comment from the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The remove-hierarchy-comment action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_removeHierarchyComment = (
  state: HierarchyContextProps,
  action: IHierarchyActionRemoveHierarchyComment,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  return hcr_updateChangedFlag(
    {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        comments: state.hierarchy.comments.filter((c) => c.id !== action.commentId),
      },
    },
    action,
  );
};
